import { useState } from "react";

// componentes
import iconCanasta from "../../../../../assets/img/icons/ventas/canasta.svg";
import BotonAgregar from "../../../../componentsUI/formularios/button/ButtonAgregar.js";
import "./CanastaOrdenes.css";

// Contexto de facturas para agregar las ordenes seleccionadas a la factura pendiente
import { useFacturas } from "../../../../contexto/provider/FacturasContext.js";
// Contexto de mesa para obtener las ordenes seleccionadas
import { useMesa } from "../../../../contexto/provider/MesaContext.js";
// Contexto de ordenes para obtener las ordenes seleccionadas
import { useOrdenes } from "../../../../contexto/provider/OrdenesContext.js";

// Servicio para construir factura desde ordenes seleccionadas-
import { construirFactura } from "../../../../../core/facturacion/domain/entities/Factura.js";
import { formatearPrecio } from "../../../../../utils/precios.js";

export default function CanastaOrdenes() {
  // Contextos
  const { agregarFacturas } = useFacturas();
  const { ordenesSeleccionadas, limpiarSeleccion } = useOrdenes();
  const { eliminarOrdenDeMesa } = useMesa();

  // Estados
  const [abierta, setAbierta] = useState(false);
  const [mostrarDialog, setMostrarDialog] = useState(false);

  // Calcular el total de la orden
  const totalSeleccionado = ordenesSeleccionadas.reduce(
    (acc, orden) => acc + orden.total,
    0,
  );
  // Función para FacturasContext ordenes seleccionadas
  const facturarOrdenesContext = () => {
    console.log("[OrdenesContext] ordenesSeleccionadas:", ordenesSeleccionadas);

    // Agregar ordenes a factura en BD
    const factura = construirFactura({ ordenesSeleccionadas });
    console.log(" [Factura domain entities] :", factura);
    if (!factura) return;

    // Agregar factura al contexto global
    agregarFacturas([factura]);
    console.log("[FacturasContext] Factura agregada:", factura);

    // Eliminar cada orden facturada
    // Agrupar por mesa
    const ordenesPorMesa = ordenesSeleccionadas.reduce((acc, orden) => {
      if (!acc[orden.mesaId]) acc[orden.mesaId] = [];
      acc[orden.mesaId].push(orden.index);
      return acc;
    }, {});
    console.log("[OrdenesContext] Ordenes agrupadas por mesa:", ordenesPorMesa);

    // Eliminar ordenadamente
    Object.entries(ordenesPorMesa).forEach(([mesaId, indices]) => {
      // Ordenar índices de mayor a menor
      indices.sort((a, b) => b - a);
      indices.forEach((index) => {
        eliminarOrdenDeMesa(mesaId, index);
      });
    });
    console.log("[OrdenesContext] Ordenes eliminadas de mesa:", ordenesPorMesa);

    limpiarSeleccion();
    // cerrar panel y mostrar dialog de éxito
    setAbierta(false);
    setMostrarDialog(true);
    setTimeout(() => setMostrarDialog(false), 3000);
  };

  return (
    <>
      <div className="canasta-barra">
        <button className="canasta-boton" onClick={() => setAbierta(true)}>
          <img src={iconCanasta} alt="Órdenes" />
          <span>Ver órdenes</span>
          <span>({ordenesSeleccionadas.length})</span>
        </button>
      </div>

      {abierta && (
        <div className="canasta-panel abierta">
          <div className="canasta-header">
            <span>Órdenes ({ordenesSeleccionadas.length})</span>
            <button onClick={() => setAbierta(false)}>✕</button>
          </div>

          <div className="canasta-contenido">
            {ordenesSeleccionadas.length === 0 ? (
              <div className="canasta-vacia">No hay órdenes seleccionadas</div>
            ) : (
              ordenesSeleccionadas.map((orden, i) => (
                <div className="orden-resumen-card">
                  {/* HEADER */}
                  <div className="orden-resumen-header">
                    <div>
                      <span className="orden-mesa">
                        Mesa {orden.mesaId} - {orden.productos.length} productos
                      </span>
                      <span className="orden-fecha">
                        {new Date(orden.fecha).toLocaleString("es-ES", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>

                    <span className="orden-total">
                      $ {formatearPrecio(orden.total)}
                    </span>
                  </div>

                  {/* LISTA DE PRODUCTOS */}
                  <ul className="orden-productos-lista">
                    {orden.productos.map((p, idx) => (
                      <li key={idx}>
                        {p.cantidad}× {p.nombre}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            )}
          </div>

          <div className="canasta-footer">
            <div>Total a pagar: {formatearPrecio(totalSeleccionado)} </div>
            <BotonAgregar
              texto="Crear factura"
              onClick={facturarOrdenesContext}
              disabled={ordenesSeleccionadas.length === 0}
            />
          </div>
        </div>
      )}
      <dialog open={mostrarDialog} className="factura-dialog">
        <p>✅ Factura creada con éxito</p>
        <button onClick={() => setMostrarDialog(false)}>Cerrar</button>
      </dialog>
    </>
  );
}
